import { useEffect, useState } from 'react';
import { rentalsService } from '../services/api';
import { AppNav } from '../components/AppNav';

interface TenantRow {
  id: string;
  name: string;
  whatsapp: string | null;
  phone: string | null;
  email: string | null;
  has_curp: boolean;
}

export default function RentalTenantsPage() {
  const [items, setItems] = useState<TenantRow[]>([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    rentalsService
      .listTenants<TenantRow>()
      .then((r) => setItems(r.items))
      .catch(() => setError('No se pudieron cargar los inquilinos.'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-[100dvh] bg-background">
      <AppNav />
      <main className="max-w-4xl mx-auto px-6 py-8">
        <h1 className="text-2xl font-semibold tracking-tight mb-6">Inquilinos</h1>
        {error && <p className="text-sm text-destructive mb-4">{error}</p>}
        {loading ? (
          <p className="text-sm text-muted-foreground">Cargando…</p>
        ) : items.length === 0 ? (
          <p className="text-sm text-muted-foreground">Sin inquilinos registrados.</p>
        ) : (
          <div className="space-y-2">
            {items.map((t) => (
              <div key={t.id} className="flex items-center justify-between border border-border rounded-xl px-4 py-3 bg-card text-sm">
                <span className="font-medium">{t.name}</span>
                <span className="text-muted-foreground">
                  {t.whatsapp ?? t.phone ?? t.email ?? '—'} {t.has_curp && '· CURP ✓'}
                </span>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
